import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

const Language = lazy(() => import('./Index'));

export default function SuspendedLanguageSettingsPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Language {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
